import React, { useState, useEffect } from 'react';
import Loading from "../Loading";
import { Text } from '../index';
import styled from 'styled-components';

const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100vh;
	width: 100%;
`;

const TextContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 2px;
`;

const LoadingText = styled(Text)`
	text-align: left;
`;

const Dots = styled.span`
	display: inline-block;
	min-width: 20px;
	font-size: 24px;
	line-height: 24px;
	margin-left: -2px;
`;

const QuestionaryLoading = () => {
	const [dots, setDots] = useState('.');

	useEffect(() => {
		const interval = setInterval(() => {
			setDots(prev => {
				if (prev.length === 3) return '.';
				return prev + '.';
			});
		}, 500);

		return () => clearInterval(interval);
	}, []);

	return (
		<LoadingContainer>
			<Loading height="130px" size="md" />
			<TextContainer>
				<LoadingText size="large" weight="medium">
					Enviando suas respostas
				</LoadingText>
				<Dots>{dots}</Dots>
			</TextContainer>
		</LoadingContainer>
	);
};

export default QuestionaryLoading;

